import { useCallback, useEffect, useMemo, useState } from 'react';

import { Occupation, Variable } from '@restworld/utility-types';
import { useTaxonomyService } from '@restworld/data-services';

export const useOccupationsByDomainInterest = ({
  domainInterestId,
  domainInterest,
}: {
  domainInterestId: string;
  domainInterest: Variable[];
}) => {
  const [loading, setLoading] = useState(false);
  const [occupationOptions, setOccupationOptions] = useState<Occupation[]>([]);
  const taxonomyService = useTaxonomyService();
  const occupationOptionsCp: Variable[] = useMemo(
    () =>
      occupationOptions.map((v) => ({
        id: v.id.toString(),
        key: v.id.toString(),
        label: v.label_it.label,
        description: v.label_it.description,
      })),
    [occupationOptions]
  );

  const getOccupationOptions = useCallback(async () => {
    if (!domainInterestId) return;
    try {
      let domainInterestIdCp = '';
      const findIndex = domainInterest.findIndex((v) => v.id === domainInterestId);
      if (findIndex > -1) domainInterestIdCp = String(domainInterest[findIndex]['id']);
      setLoading(true);
      const response = await taxonomyService.indexOccupations(domainInterestIdCp);
      setOccupationOptions(response.data);
    } catch (error) {
      console.error(`error fetching occupation`, error);
    } finally {
      setLoading(false);
    }
  }, [domainInterest, domainInterestId, taxonomyService]);

  useEffect(() => {
    getOccupationOptions();
  }, [getOccupationOptions]);

  const returnV = useMemo(
    () => ({
      loading,
      occupationOptions: occupationOptionsCp,
    }),
    [loading, occupationOptionsCp]
  );
  return returnV;
};
